import {
  generateSRPUri,
  HgSupportedLanguage,
  SearchModel,
  type SRPUri,
  type UrlNameResolver,
} from '@smg-real-estate/hg-search-libs';
import { type RouteLocationNormalized } from 'vue-router';
import { type Store } from 'vuex';

import { getCurrentTargetPlatform, isPlatformIs24 } from '@/helpers/platformDetection';
import {
  getLayoutSolutionRequestQueryParameters,
  isLayoutSolutionActive,
} from '@/resultlist/layoutSolutionRequest';

import { urlNameByGeoIdResolver } from '@/resultlist/seoUrlPartResolver';

export function generateLayoutSolutionSRPRoute(
  language: HgSupportedLanguage,
  searchModel: SearchModel,
  urlNameResolver: UrlNameResolver,
): SRPUri {
  return generateSRPUri({
    language,
    searchModel,
    urlNameResolver,
    maxLocationsInPath: 1,
    maxSubCategoriesInPath: 3,
    platform: getCurrentTargetPlatform(),
  });
}

export function createLayoutSolutionSRPRoute(
  language: HgSupportedLanguage,
  searchModel: SearchModel,
  $route: RouteLocationNormalized,
  $store: Store<any>,
): SRPUri {
  // Check if we need to preserve the path due to aa=purchorrentall workaround
  const hasAaWorkaround = $route.query.aa === 'purchorrentall';

  // Always generate the route to get correct query parameters from searchModel
  const route = generateLayoutSolutionSRPRoute(
    language,
    searchModel,
    urlNameByGeoIdResolver($store, getCurrentTargetPlatform()),
  );

  if (hasAaWorkaround) {
    // When aa=purchorrentall is present, preserve the original path
    // but use the query parameters generated from the searchModel
    if (isPlatformIs24()) {
      route.path = $route.path; // Preserve original path with /immobilien/mieten IS24
    }

    // Add the aa parameter to the generated query
    route.query = {
      ...route.query,
      aa: 'purchorrentall',
    };
  }

  if (isLayoutSolutionActive($route.query)) {
    route.query = {
      ...route.query,
      ...getLayoutSolutionRequestQueryParameters($route.query),
    };
  }

  return route;
}
